import { toast } from "react-toastify";

const STORAGE_KEY = "exam_submit_message";

const extractMessage = (response) => {
  if (!response) return "";
  if (typeof response === "string") return response.trim();

  const message = response.message ?? response.data?.message ?? response.msg;
  if (typeof message === "string") return message.trim();
  if (Array.isArray(message)) return message.filter(Boolean).join("\n").trim();
  return "";
};

export const saveExamSubmitMessage = (response) => {
  const message = extractMessage(response);
  if (!message) return;
  sessionStorage.setItem(STORAGE_KEY, message);
};

export const showSavedExamSubmitMessage = () => {
  const message = sessionStorage.getItem(STORAGE_KEY);
  if (!message) return;
  sessionStorage.removeItem(STORAGE_KEY);
  toast.info(message, {
    autoClose: 10000,
    style: { whiteSpace: "pre-line" },
  });
};
